import React from 'react';
import anchorme from 'anchorme';
import { ButtonAction, scrollElementIntoView } from 'containers/PageBuilder/SinglePageContainer/domain';
import { IEventBlockPreviewProps } from './IEventBlockPreviewProps';
import { BannerBlockBackgroundImage, BannerBlockContainer, BannerBlockContentContainer } from '../BannerBlockPreview/BannerBlockPreview';
import { BlockBackgroundImageGradient } from '../BlockComponents/BlockBackgroundImage';
import BlockTextContainer, { BlockSubTextContainer } from '../BlockComponents/BlockTextContainer';
import BlockButton from '../BlockComponents/BlockButton';
import { BlockButtonsContainer, BlockSideButton } from '../ButtonBlockPreview/ButtonBlockPreview';
import miscUtils from 'utils/miscUtils';

const EventBlockPreview: React.FC<IEventBlockPreviewProps> = (props) => {

    const ctaOnClick = (blockData: any) => {
        if(props.buildingPreview) {
            return;
        }

        if(
            blockData &&
            (
                blockData.button_action === ButtonAction.URL ||
                blockData.button_action === ButtonAction.URLTab
            ) &&
            blockData.button_url
        ) {
            window.open(
                miscUtils.ensureHttps(blockData.button_url), 
                blockData.button_action === ButtonAction.URLTab ?
                '_blank' :
                '_self'
            );
            return;
        }

        if(
            blockData &&
            blockData.button_action === ButtonAction.Scroll &&
            blockData.button_url &&
            props.containerBaseIdName
        ) {
            scrollElementIntoView(`${props.containerBaseIdName}${blockData.button_url}`);
            return;
        }

        if(
            blockData &&
            blockData.button_action === ButtonAction.Popup &&
            blockData.button_url
        ) {
            let nextPageFormsOpenState = JSON.parse(JSON.stringify(props.pageFormsOpenState));

            nextPageFormsOpenState[blockData.button_url] = true;

            props.setPageFormsOpenState(nextPageFormsOpenState);
            return;
        }

        if(
            blockData &&
            blockData.button_action === ButtonAction.Page &&
            blockData.button_url
        ) {
            window.open(
                `${blockData.button_url}`, 
                '_self'
            );
            return;
        }
    }

  return (
    <BannerBlockContainer
    design={props.blockData.design}
    >
        {props.blockData.image_url ? (
            <>
            <BannerBlockBackgroundImage
            design={props.blockData.design}
            src={props.blockData.image_url}
            alt={props.blockData.image_alt}
            />
            <BlockBackgroundImageGradient
            design={props.blockData.design}
            />
            </>
        ) : <></>}

        <BannerBlockContentContainer
        className={`${props.view ? props.view : ''}`}
        design={props.blockData.design}
        >
            <BlockTextContainer
            design={props.blockData.design}
            pageStyles={props.pageStyles}
            textKey="heading"
            fallbackTextColor="#FFFFFF"
            dangerouslySetInnerHTML={{
                __html: anchorme(props.blockData.heading),
            }}
            />


            <BlockSubTextContainer
            design={props.blockData.design}
            pageStyles={props.pageStyles}
            textKey="subtext"
            fallbackTextColor="#FFFFFF"
            dangerouslySetInnerHTML={{
                __html: anchorme(props.blockData.subtext),
            }}
            />

            {props.blockData.button_shown ? (
                <BlockButtonsContainer
                className={`${props.view ? props.view : ''}`}
                >
                    <BlockButton
                    design={props.blockData.design}
                    pageStyles={props.pageStyles}   
                    onClick={() => ctaOnClick(props.blockData)}
                    >
                        {props.blockData.button_text}
                    </BlockButton>
    
                    {props.blockData.side_by_side_buttons ? (
                        props.blockData.side_by_side_buttons.map((side_by_side_button: any, index: number) => (
                            <BlockSideButton
                            key={`${index}`}
                            className={`${props.view ? props.view : ''}`}
                            design={side_by_side_button.design}
                            pageStyles={props.pageStyles}
                            onClick={() => ctaOnClick(side_by_side_button)}
                            >
                                {side_by_side_button.button_text}
                            </BlockSideButton>
                        ))
                    ) : <></>}
                </BlockButtonsContainer>
            ) : <></>}
        </BannerBlockContentContainer>
    </BannerBlockContainer>
  )
}

export default EventBlockPreview;